import React from 'react';
import Webcam from 'react-webcam';
import styles from './index.module.scss';
import { convertBase64ToFile } from 'utils/fileUtils';
const videoConstraints = {
  facingMode: 'environment',
};
const WebcamImagePickerModal = (props) => {
  const { submitImage, toggleModal, submitFile } = props;
  const webcamRef: any = React.useRef(null);
  const [imgSrc, setImgSrc] = React.useState('');

  const handleSubmitImage = React.useCallback(async () => {
    const imageSrc = webcamRef?.current.getScreenshot();
    setImgSrc(imageSrc);
    submitFile &&
      submitFile(
        await convertBase64ToFile(imageSrc, '', {
          type: 'image/jpeg',
        }),
      );
    submitImage && submitImage(imgSrc);
    toggleModal();
  }, [webcamRef, setImgSrc]);

  return (
    <form
      onSubmit={(e) => e.preventDefault()}
      className={styles['main-container']}
    >
      <div className={styles['modal-container']}>
        <div className={styles['modal-header']}>
          <div>
            <div className={styles['label']}>Click Image</div>
          </div>
          <i className={'fa fa-times'} onClick={toggleModal} />
        </div>
        <div className={styles['modal-body']}>
          <Webcam
            // style={{ width: '80%', height: '90%' }}
            className={styles['webcam-view']}
            audio={false}
            forceScreenshotSourceSize={true}
            screenshotFormat={'image/jpeg'}
            videoConstraints={videoConstraints}
            ref={webcamRef}
          />
        </div>
        <div className={styles['modal-footer']}>
          <button
            onClick={toggleModal}
            className={styles['cancel-button']}
          >
            Cancel
          </button>
          <button
            onClick={handleSubmitImage}
            className={styles['submit-button']}
          >
            Capture
          </button>
        </div>
      </div>
    </form>
  );
};
export default WebcamImagePickerModal;
